import { Component, OnInit ,ViewChild} from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { CucurachaAdminService } from '../service/cucuracha.service';
@Component({
  selector: 'app-systemlogsmanagement',
  templateUrl: './systemlogsmanagement.component.html',
  styleUrls: ['./systemlogsmanagement.component.css']
})
export class SystemlogsmanagementComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: any;
  displayedColumns = ['adminId', 'login','loggedDevice','loggedBrowser','logout']
 
  constructor(private cs:CucurachaAdminService) { }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
  getAllSysLogs(){
    this.cs.getSysLogs().subscribe((data) => {
      this.dataSource = new MatTableDataSource(data)
  this.dataSource.sort = this.sort
  this.dataSource.paginator = this.paginator
    })
  }
  ngOnInit(): void {
    this.getAllSysLogs();
  }
  
  
}
